export const MINFIN_DEVELOPMENT = {
  UA: 'https://minfin.com.ua/ua/developers/api/',
  RU: 'https://minfin.com.ua/developers/api/',
};
